import { getReportRepository } from "../Infrastructure/Reports.repository";

export async function getReportLogic(type, filter) {
  return getReportRepository(type, filter);
}
